module.exports = __webpack_public_path__ + "img/door.cc0131f9.svg";